const API = ("" || "") + "/api/my";

async function req(path, opts = {}) {
  const res = await fetch(`${API}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(opts.headers || {}) },
    ...opts,
  });
  if (res.status === 401) {
    const err = new Error("unauthenticated"); err.status = 401; throw err;
  }
  if (!res.ok) {
    let msg = "Erro";
    try { const j = await res.json(); msg = j.detail || j.message || msg; }
    catch (e) { if (process.env.NODE_ENV !== 'production') console.debug('myApi.req: non-JSON error body', res.status); }
    const err = new Error(msg); err.status = res.status; throw err;
  }
  return res.json();
}

async function upload(path, file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${API}${path}`, { method: "POST", credentials: "include", body: fd });
  if (!res.ok) {
    let msg = "Erro ao enviar";
    try { const j = await res.json(); msg = j.detail || msg; }
    catch (e) { if (process.env.NODE_ENV !== 'production') console.debug('myApi.upload: non-JSON error body', res.status); }
    throw new Error(msg);
  }
  return res.json();
}

export const PHOTO_URL = `${API}/info/foto`;

export const myApi = {
  login: (email, password) => req("/auth/login", { method: "POST", body: JSON.stringify({ email, password }) }),
  me: () => req("/auth/me"),
  logout: () => req("/auth/logout", { method: "POST" }),
  propostasList: () => req("/eventos/propostas"),
  propostaGet: (id) => req(`/eventos/proposta/${id}`),
  propostaGuardar: (body) => req("/eventos/proposta/guardar", { method: "POST", body: JSON.stringify(body) }),
  propostaEditar: (id, body) => req(`/eventos/proposta/${id}`, { method: "PUT", body: JSON.stringify(body) }),
  propostaDecidir: (id, modo_pagamento) => req(`/eventos/proposta/${id}/decidir`, { method: "POST", body: JSON.stringify({ modo_pagamento }) }),
  proposta5050: (id, id_morada_fatura) => req(`/eventos/proposta/${id}/gerar-5050`, { method: "POST", body: JSON.stringify({ id_morada_fatura }) }),
  propostaCancelar: (id) => req(`/eventos/proposta/${id}/cancelar`, { method: "POST" }),
  tourScenes: () => req("/tour/scenes"),
  tourStatus: () => req("/tour/status"),
  tourMarkSeen: () => req("/tour/seen", { method: "POST" }),

  dashboard: () => req("/dashboard"),

  eventosConfig: () => req("/eventos/config"),
  eventosFormadores: () => req("/eventos/formadores"),
  eventosProposta: (payload) => req("/eventos/proposta", { method: "POST", body: JSON.stringify(payload) }),
  eventosLead: (payload) => req("/eventos/lead", { method: "POST", body: JSON.stringify(payload) }),

  // Info pessoal
  perfil: () => req("/info/perfil"),
  perfilEmails: (page = 1, pageSize = 10) => req(`/info/perfil/emails?page=${page}&page_size=${pageSize}`),
  perfilUpdate: (payload) => req("/info/perfil", { method: "POST", body: JSON.stringify(payload) }),
  accountDeactivate: () => req("/info/account/deactivate", { method: "POST" }),
  nifUsage: (nif) => req("/info/nifUsage", { method: "POST", body: JSON.stringify({ nif }) }),
  changePassword: (oldPassword, newPassword) =>
    req("/info/password", { method: "POST", body: JSON.stringify({ oldPassword, newPassword }) }),

  uploadPhoto: (file) => upload("/info/foto", file),
  deletePhoto: () => req("/info/foto", { method: "DELETE" }),

  // Moradas CRUD
  moradas: () => req("/info/moradas"),
  moradaCreate: (p) => req("/info/moradas", { method: "POST", body: JSON.stringify(p) }),
  moradaUpdate: (id, p) => req(`/info/moradas/${id}`, { method: "PUT", body: JSON.stringify(p) }),
  moradaDelete: (id) => req(`/info/moradas/${id}`, { method: "DELETE" }),
  moradaTipos: () => req("/info/moradas/tipos"),

  // Contactos CRUD
  contactos: () => req("/info/contactos"),
  contactoCreate: (p) => req("/info/contactos", { method: "POST", body: JSON.stringify(p) }),
  contactoUpdate: (id, p) => req(`/info/contactos/${id}`, { method: "PUT", body: JSON.stringify(p) }),
  contactoDelete: (id) => req(`/info/contactos/${id}`, { method: "DELETE" }),
  contactoTipos: () => req("/info/contactos/tipos"),

  // Reference
  paises: () => req("/ref/paises"),
  moedas: () => req("/ref/moedas"),
  linguas: () => req("/ref/linguas"),

  // Alertas
  alertas: () => req("/alertas"),
  alertaToggle: (tipo, subscribe) =>
    req(`/alertas/${tipo}`, { method: "POST", body: JSON.stringify({ subscribe }) }),

  // Encomendas
  orders: (estado, page = 1, pageSize = 20) =>
    req(`/encomendas/list?page=${page}&page_size=${pageSize}${estado ? `&estado=${estado}` : ""}`),
  orderStates: () => req("/encomendas/states"),
  orderFullDetail: (id) => req(`/encomendas/${id}/fullDetail`),
  orderCancel: (id) => req(`/shop/orders/${id}/cancel`, { method: "POST" }),

  // Subscrições
  subscriptions: () => req("/subscricoes"),

  // Vales
  vales: (status) => req(`/vales${status ? `?status=${status}` : ""}`),
  valesResumo: () => req("/vales/resumo"),
  valesUtilizacoes: () => req("/vales/utilizacoes"),
  valesActivate: (codigo) =>
    req("/vales/activate", { method: "POST", body: JSON.stringify({ Codigo_Vale: codigo }) }),
  valesActivateByGuid: (guid) =>
    req("/vales/activate-by-guid", { method: "POST", body: JSON.stringify({ GUID: guid }) }),
  valesSend: (codigo, email) =>
    req("/vales/send", { method: "POST", body: JSON.stringify({ Codigo_Vale: codigo, Email: email }) }),

  // Prémios
  premios: () => req("/premios"),

  // Comissões
  comissoesResumo: () => req("/comissoes/resumo"),
  comissoesPagamentos: (page = 1, pageSize = 20) =>
    req(`/comissoes/pagamentos?page=${page}&page_size=${pageSize}`),
  comissoesAcumulado: () => req("/comissoes/acumulado"),
  comissoesTransferirCreditos: (valor) =>
    req("/comissoes/transferir-creditos", { method: "POST", body: JSON.stringify({ valor }) }),

  // Recomendar (link pessoal de afiliado + KPIs)
  recomendar: () => req("/recomendar"),

  // Consultor dedicado
  consultor: () => req("/consultor"),

  // Formador (Trainer) info — só devolve dados se o cliente estiver ligado a Tinf_Formador
  formadorInfo: () => req("/formador-info"),
  formadorPerfilUpdate: (payload) => req("/formador/perfil", { method: "PUT", body: JSON.stringify(payload) }),

  // Mod. 16 (Reação do Formador) — consulta/submissão pelo próprio formador
  formadorAvaliacao: (idCurso) => req(`/formador/curso/${idCurso}/avaliacao`),
  formadorAvaliacaoSubmit: (idCurso, payload) =>
    req(`/formador/curso/${idCurso}/avaliacao`, {
      method: "POST", body: JSON.stringify(payload),
    }),

  // Catálogo Revenda (consultores)
  revendaProducts: () => req("/revenda/products"),

  // Programa MUDAR DE VIDA
  mvStatus: () => req("/mudardevida/status"),
  mvDesafios: () => req("/mudardevida/desafios"),
  mvOpcoesFinal: () => req("/mudardevida/opcoes-final-semana"),
  mvResultados: () => req("/mudardevida/resultados"),
  mvSubscribe: (ID_Desafio = 1) =>
    req("/mudardevida/subscribe", { method: "POST", body: JSON.stringify({ ID_Desafio }) }),
  mvUnsubscribe: () => req("/mudardevida/unsubscribe", { method: "POST" }),
  mvSubmitResultado: (payload) =>
    req("/mudardevida/resultado", { method: "POST", body: JSON.stringify(payload) }),

  // Shop — Cart
  cartGet: () => req("/shop/cart"),
  cartAdd: (ID_Produto, Quantidade = 1, TypeOfUpdate = "soma") =>
    req("/shop/cart/add", { method: "POST", body: JSON.stringify({ ID_Produto, Quantidade, TypeOfUpdate }) }),
  cartAddPack: (ID_Pack, Quantidade = 1) =>
    req("/shop/cart/addPack", { method: "POST", body: JSON.stringify({ ID_Pack, Quantidade }) }),
  cartUpdateQty: (ProductId, Quantity) =>
    req("/shop/cart/update", { method: "POST", body: JSON.stringify({ ProductId, Quantity }) }),
  cartRemove: (ProductId) =>
    req("/shop/cart/remove", { method: "POST", body: JSON.stringify({ ProductId }) }),
  cartRemovePack: (PackId) =>
    req("/shop/cart/removePack", { method: "POST", body: JSON.stringify({ PackId }) }),
  cartClear: () => req("/shop/cart/clear", { method: "POST" }),

  // Shop — Addresses
  shopDeliveryAddresses: () => req("/shop/addresses/delivery"),
  shopBillingAddresses: () => req("/shop/addresses/billing"),
  shopAddressGet: (id) => req(`/shop/addresses/${id}`),
  shopAddressAdd: (payload) =>
    req("/shop/addresses/add", { method: "POST", body: JSON.stringify(payload) }),
  shopAddressUpdate: (payload) =>
    req("/shop/addresses/update", { method: "POST", body: JSON.stringify(payload) }),
  shopAddressRemove: (ID_Cliente_Morada) =>
    req("/shop/addresses/remove", { method: "POST", body: JSON.stringify({ ID_Cliente_Morada }) }),
  shopAddressSetDefaultShipping: (AddressId) =>
    req("/shop/addresses/setDefaultShipping", { method: "POST", body: JSON.stringify({ AddressId }) }),
  shopAddressSetDefaultBilling: (AddressId) =>
    req("/shop/addresses/setDefaultBilling", { method: "POST", body: JSON.stringify({ AddressId }) }),

  // Shop — Checkout
  shopDeliveryMethods: () => req("/shop/checkout/deliveryMethods"),
  shopPaymentMethods: () => req("/shop/checkout/paymentMethods"),
  shopCartFlags: () => req("/shop/checkout/cart-flags"),
  shopCheckoutDefaults: () => req("/shop/checkout/defaults"),
  shopBalances: () => req("/shop/checkout/balances"),
  shopCheckoutVerify: (payload) =>
    req("/shop/checkout/verify", { method: "POST", body: JSON.stringify(payload) }),
  shopCheckoutConfirm: (payload) =>
    req("/shop/checkout/confirm", { method: "POST", body: JSON.stringify(payload) }),

  // Shop — Payment
  shopPaymentOrder: (idEncomenda) => req(`/shop/payment/order/${idEncomenda}`),
  shopPaymentByHash: (hashEncomenda) => req(`/shop/payment/order-by-hash/${encodeURIComponent(hashEncomenda)}`),
  shopPaymentChange: (payload) =>
    req("/shop/payment/change", { method: "POST", body: JSON.stringify(payload) }),
  shopPaypalConfirmed: (payload) =>
    req("/shop/payment/paypal/confirmed", { method: "POST", body: JSON.stringify(payload) }),
  shopPaypalCanceled: (payload) =>
    req("/shop/payment/paypal/canceled", { method: "POST", body: JSON.stringify(payload) }),
  shopEbanxUrl: (payload) =>
    req("/shop/payment/ebanx/url", { method: "POST", body: JSON.stringify(payload) }),

  shopCountries: () => req("/shop/ref/countries"),

  // Shop — Product search (para adicionar ao carrinho)
  shopProductSearch: (q = "") =>
    req(`/shop/products/search?q=${encodeURIComponent(q)}`),

  // Coach Virtual — Roda da Vida + Auto-análise PNL
  coachRodaMeta: () => req("/coach/roda/meta"),
  coachRodaHistory: () => req("/coach/roda/history"),
  coachRodaGet: (id) => req(`/coach/roda/${id}`),
  coachRodaSave: (payload) =>
    req("/coach/roda/save", { method: "POST", body: JSON.stringify(payload) }),
  coachRodaDelete: (id) => req(`/coach/roda/${id}`, { method: "DELETE" }),
  coachRodaInsights: (id) =>
    req(`/coach/roda/${id}/insights`, { method: "POST", body: "{}" }),
  coachRodaAnalise: (id) =>
    req(`/coach/roda/${id}/analise`, { method: "POST", body: "{}" }),
  coachRodaAnaliseArea: (id, area) =>
    req(`/coach/roda/${id}/analise-area`, {
      method: "POST",
      body: JSON.stringify({ area }),
    }),
  mentorChat: (payload) =>
    req("/coach/mentor/chat", { method: "POST", body: JSON.stringify(payload) }),
  mentorConversas: () => req("/coach/mentor/conversas"),
  mentorConversa: (id) => req(`/coach/mentor/conversas/${id}`),
  mentorConversaDelete: (id) =>
    req(`/coach/mentor/conversas/${id}`, { method: "DELETE" }),

  casalEstado: () => req("/coach/casal"),
  casalConvite: (email) =>
    req("/coach/casal/convite", { method: "POST", body: JSON.stringify({ email }) }),
  casalResponder: (aceitar) =>
    req("/coach/casal/responder", { method: "POST", body: JSON.stringify({ aceitar }) }),
  casalTerminar: () => req("/coach/casal", { method: "DELETE" }),
  casalAnalise: () => req("/coach/casal/analise", { method: "POST", body: "{}" }),
  casalMetas: () => req("/coach/casal/metas"),
  casalMetaCriar: (payload) =>
    req("/coach/casal/metas", { method: "POST", body: JSON.stringify(payload) }),
  casalMetaToggle: (id) =>
    req(`/coach/casal/metas/${id}/toggle`, { method: "POST", body: "{}" }),
  casalMetaApagar: (id) =>
    req(`/coach/casal/metas/${id}`, { method: "DELETE" }),
  casalPartilhar: () =>
    req("/coach/casal/partilhar", { method: "POST", body: "{}" }),
  casalPartilharRevogar: () =>
    req("/coach/casal/partilhar", { method: "DELETE" }),

  // Self-Talk (Helmstetter + PNL) + biblioteca de áudios mp3
  selfTalkGenerate: (areas) =>
    req("/coach/selftalk/generate", { method: "POST", body: JSON.stringify({ areas }) }),
  selfTalkHistory: () => req("/coach/selftalk/history"),
  selfTalkDelete: (id) => req(`/coach/selftalk/${id}`, { method: "DELETE" }),
  selfTalkAudios: () => req("/coach/selftalk/audios"),
  selfTalkAudioUpload: (file) => upload("/coach/selftalk/audios", file),
  selfTalkAudioDelete: (id) => req(`/coach/selftalk/audio/${id}`, { method: "DELETE" }),
};

